import React, { useState, useRef, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router
import { Link } from 'react-router-dom'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// includes
import CouponsFormContentView from './Includes/CouponsFormContentView'

// APIs
import { getCouponDetails, cancelGetCouponDetailsApi, editCoupon } from 'utlis/Apis/Coupons_API'
import { getCategories, cancelGetCategoriesApi } from 'utlis/Apis/Categories_API'
import { getBrands, cancelGetBrandsApi } from 'utlis/Apis/Brands_API'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// app messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    COUPON_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_COUPON,
    ERROR_WHILE_GETTING_COUPON_DETAILS
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function EditCoupon(props) {
    // props
    const { authState } = props

    // refs
    const submitButtonRef = useRef(null)

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)

    const [couponId, setCouponId] = useState("")
    const [categoriesList, setCategoriesList] = useState([])
    const [defaultCategoriesList, setDefaultCategoriesList] = useState("")
    const [brandsList, setBrandsList] = useState("")
    const [coupon, setCoupon] = useState({})
    // const [defaultBrandsList, setDefaultBrandsList] = useState([])

    // getting categories
    useEffect(() => {
        let URLParams = `limit=-1`
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCategories(headers, URLParams).then(res => {
            const resData = res.data

            // if request succesfull
            if (resData && resData.success) {
                const filteredData = resData?.data?.map(item => {
                    return { value: item.category_id, label: item.category_name }
                })
                setCategoriesList(filteredData)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategories `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        return () => {
            cancelGetCategoriesApi()
        }
    }, [authState])

    // getting brands
    useEffect(() => {
        let URLParams = `limit=-1`

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }

        getBrands(headers, URLParams).then(res => {
            const resData = res.data
            // if request succesfull
            if (resData && resData.success) {
                const filteredData = resData?.data?.map(item => {
                    return { value: item.manufacturer_id, label: item.manufacturer_name }
                })
                setBrandsList(filteredData)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        })
        return () => {
            cancelGetBrandsApi()
        }
    }, [authState])

    // initial form values
    const initialEditFormValues = {
        couponCode: coupon.coupon_code || "",
        couponDiscountType: (coupon.discount_type === 1 ? "percent" : "value") || "",
        couponDiscountPercent: coupon.discount_value || "",
        couponDiscountValue: coupon.discount_value || "",
        couponExpiryDate: coupon.expiry_date || "",
        couponCategories: coupon.category_ids || "",
        couponBrands: coupon.vendor_ids || "",
        couponMinOrderAmount: coupon.minimum_order_amount || "",
        couponStatus: coupon.is_active || "1",
        couponAutoApply: coupon.auto_apply || false,
        couponFreeShiping: coupon.free_shipping ? true : false || false,
        couponSingleUse: coupon.single_use ? true : false || false,
        couponSingleUsePerUser: coupon.single_use_per_user ? true : false || false,
    }

    // handle form validations
    const editFormValidationSchema = Yup.object().shape({
        couponCode: Yup.string().required('This field is required'),
        couponDiscountType: Yup.string().required('This field is required'),
        couponDiscountPercent: Yup.string().when('couponDiscountType', {
            is: "percent",
            then: Yup.string().required('This field is required')
        }),
        couponDiscountValue: Yup.string().when('couponDiscountType', {
            is: "value",
            then: Yup.string().required('This field is required')
        }),
        couponExpiryDate: Yup.string().required('This field is required'),
        couponCategories: Yup.string(),
        couponBrands: Yup.string(),
        couponMinOrderAmount: Yup.string(),
        couponAutoApply: Yup.string(),
        couponFreeShiping: Yup.string(),
        couponStatus: Yup.string(),
        couponSingleUse: Yup.bool(),
        couponSingleUsePerUser: Yup.bool(),
    }, [['couponDiscountPercent', 'couponDiscountValue']])

    // getting coupon id from the url
    useEffect(() => {
        const idFromUrl = props.match.params;
        // setting user id from the url
        if (idFromUrl) {
            setCouponId(idFromUrl.id)
        }
    }, [props.match.params])

    // getting coupon details from the location state 
    useEffect(() => {
        const locState = props.location.state ?? props.location.state
        // if state with the coupon data exists in the location state
        if (locState) {
            const couponData = locState.couponDetails
            console.log("couponData ", couponData)
            // setting the form fields
            // setDefaultBrandsList(couponData?.vendor_ids ?? "")
            setCoupon(couponData)
            setDefaultCategoriesList(couponData?.category_ids ?? "")
            // formik.setFieldValue("couponCode", couponData?.coupon_code ?? "")
            // formik.setFieldValue("couponDiscountType", (couponData?.discount_type === 1 ? "percent" : "value") ?? "")
            // formik.setFieldValue("couponDiscountPercent", couponData?.discount_value ?? "")
            // formik.setFieldValue("couponDiscountValue", couponData?.discount_value ?? "")
            // formik.setFieldValue("couponExpiryDate", couponData?.expiry_date ?? "")
            // formik.setFieldValue("couponCategories", couponData?.category_ids ?? "")
            // formik.setFieldValue("couponBrands", couponData?.vendor_ids ?? "")
            // formik.setFieldValue("couponMinOrderAmount", couponData?.minimum_order_amount ?? "")
            // formik.setFieldValue("couponStatus", couponData?.is_active ?? "")
            // formik.setFieldValue("couponAutoApply", couponData?.auto_apply ?? "")
            // formik.setFieldValue("couponFreeShiping", couponData?.free_shipping ? true : false ?? false)
            // formik.setFieldValue("couponSingleUse", couponData?.single_use ? true : false ?? false)
            // formik.setFieldValue("couponSingleUsePerUser", couponData?.single_use_per_user ? true : false ?? false)
        }
    }, [props])

    // getting coupon details from the database with the id from the url
    useEffect(() => {
        const locState = props.location.state ?? props.location.state
        // if state with the coupon data does not exist in the location state

        if (!locState) {
            // enabling the global loading
            props.setGlobalLoading(true)

            // getting the coupon from the database
            const couponId = props.match.params.id ?? ""

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // getting coupon details
            getCouponDetails(headers, couponId).then(res => {
                console.log("res ", res)
                const couponData = res.data
                // disabling the global loading
                props.setGlobalLoading(false)

                // if request is success
                if (couponData.success) {
                    // setting the form fields
                    setCoupon(couponData?.data || {})
                    // formik.setFieldValue("couponCode", couponData?.data?.coupon_code ?? "")
                    // formik.setFieldValue("couponDiscountType", (couponData?.data?.discount_percent == 1 ? "percent" : "value") ?? "")
                    // formik.setFieldValue("couponDiscountPercent", couponData?.data?.discount_value ?? "")
                    // formik.setFieldValue("couponDiscountValue", couponData?.data?.discount_value ?? "")
                    // formik.setFieldValue("couponExpiryDate", couponData?.data?.expiry_date ?? "")
                    // formik.setFieldValue("couponMinOrderAmount", couponData?.data?.minimum_order_amount ?? "")
                    // formik.setFieldValue("couponStatus", couponData?.data?.is_active ?? "")
                    // formik.setFieldValue("couponAutoApply", couponData?.data?.auto_apply ?? "")
                    // formik.setFieldValue("couponFreeShiping", couponData?.data?.free_shipping ? true : false ?? false)
                    // formik.setFieldValue("couponSingleUse", couponData?.data?.single_use ? true : false ?? false)
                    // formik.setFieldValue("couponSingleUsePerUser", couponData?.data?.single_use_per_user ? true : false ?? false)
                }

                // // if request is not succeed
                if (couponData.error) {
                    console.log(ERROR_WHILE_GETTING_COUPON_DETAILS, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_GETTING_COUPON_DETAILS, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCouponDetails `, err.message)

                // disabling the global loading
                props.setGlobalLoading(false)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                })
            })

            return () => {
                // canceling get coupon api when user leaves the component
                cancelGetCouponDetailsApi()
            }
        }
    }, [props])

    // handle form submmision
    const onEditFormSubmit = values => {
        if (values) {
            // enabling global loading
            setGlobalLoading(true)

            // enabling the button and enabling loading
            setEditButtonDisable(true)
            setEditButtonLoading(true)

            // saving the data in the database
            const dataToBeSaved = {
                coupon_id: couponId,
                coupon_code: values.couponCode,
                discount_percent: (values.couponDiscountType === "percent") ? 1 : 0,
                discount_value: (values.couponDiscountType === "percent") ? values.couponDiscountPercent : values.couponDiscountValue,
                expiry_date: values.couponExpiryDate,
                category_ids: values.couponCategories,
                vendor_ids: values.couponBrands,
                minimum_order_amount: values.couponMinOrderAmount,
                is_active: values.couponStatus,
                auto_apply: values.couponAutoApply,
                free_shipping: values.couponFreeShiping,
                single_use: values.couponSingleUse,
                single_use_per_user: values.couponSingleUsePerUser,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // saving data
            editCoupon(headers, dataToBeSaved).then(res => {
                // disabling global loading
                setGlobalLoading(false)

                // enabling the button and disabling loading
                setEditButtonDisable(false)
                setEditButtonLoading(false)

                const addingData = res.data

                // if request is success
                if (addingData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(COUPON_UPDATED_SUCCESSFULLY, {
                        autoClose: 2500,
                        onClose: () => {
                            // enabling the edit button
                            setEditButtonDisable(false)
                        }
                    })
                }

                // if request is not succeed
                if (addingData.error) {
                    console.log(ERROR_WHILE_UPDATING_COUPON, res)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_UPDATING_COUPON, {
                        autoClose: 3000,
                        onClose: () => {
                            // enabling the button and disabling loading
                            setEditButtonDisable(false)
                        }
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} editCoupon `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling global loading
                        setGlobalLoading(false)

                        // disbling the button and enabling loading
                        setEditButtonDisable(false)
                        setEditButtonLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialEditFormValues,
        validationSchema: editFormValidationSchema,
        onSubmit: onEditFormSubmit,
        enableReinitialize: true
    })

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitButtonRef.current.click()
    }

    // handle expiry date change
    const handleDateChange = value => {
        if (value) {
            const selectedDate = new Date(value)
            console.log("selectedDate ", selectedDate)
            let date = selectedDate.getDate()
            let month = selectedDate.getMonth() + 1
            let year = selectedDate.getFullYear()

            let finalDate = `${year}-${month}-${date}`

            // setting the expiry date value in the hidden input
            formik.setFieldValue("couponExpiryDate", finalDate)
        }
    }

    // handle category change
    const handleCategoryChange = value => {
        if (value) {
            const filteredValue = value.map(item => item.value)

            // setting the category value in the hidden input
            formik.setFieldValue("couponCategories", filteredValue.toString())
        }
    }

    // handle brand change
    const handleBrandChange = value => {
        if (value) {
            const filteredValue = value.map(item => item.value)

            // setting the brand value in the hidden input
            formik.setFieldValue("couponBrands", filteredValue.toString())
        }
    }

    return (
        <section id="app-coupons__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-coupons__edit-details">
                    {/* BACK BUTTON WRAPPER */}
                    <div className="back-button-wrapper mb-2">
                        <Link to={storeUrl + "/catalog/coupons"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to coupons</span>
                        </Link>
                    </div>

                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Edit Coupon</p>
                        <p className="app-desc">
                            Edit a Coupon.
                        </p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <CouponsFormContentView
                                formik={formik}
                                parentProps={props}
                                handleDateChange={handleDateChange}

                                categoriesList={categoriesList}
                                defaultCategoriesList={defaultCategoriesList}
                                handleCategoryChange={handleCategoryChange}

                                brandsList={brandsList}
                                handleBrandChange={handleBrandChange}
                            />

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/catalog/coupons"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Save Changes</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditCoupon)